import { render, staticRenderFns } from "./Xinput.vue?vue&type=template&id=5e9e6d97&"
import script from "./Xinput.vue?vue&type=script&lang=js&"
export * from "./Xinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports